import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import FieldWrapper from '../../ui/field-wrapper';
import { FIELD_TYPES } from '../../constants';
import { RadioGroupComponent } from '../../ui/radio-group/radio-group-component';
// TODO pass required to TPA component once contributed
const RadioGroup = props => {
  const {
    target,
    fieldType = FIELD_TYPES.RADIO_GROUP
  } = props;
  return /*#__PURE__*/React.createElement(FieldWrapper, {
    fieldType: fieldType,
    dataHook: target
  }, /*#__PURE__*/React.createElement(RadioGroupComponent, _extends({}, props, {
    fieldType: fieldType
  })));
};
export default RadioGroup;
//# sourceMappingURL=radio-group.js.map